import { CollectorApiService } from './service/CollectorApiService';

export const collectorApiService: CollectorApiService = new CollectorApiService();
